import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { url: String }
  static targets = ['link']

  async connect() {
    try {
      const response = await fetch(this.urlValue, { method: 'HEAD', redirect: 'manual' })
      if (response.ok && this.hasLinkTarget) {
        this.element.replaceWith(this.linkTarget.content.cloneNode(true))
      }
    } catch {
      // Network error — keep the text fallback.
    }
  }
}
